"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterimScreenRelaunchButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function InterimScreenRelaunchButton({ onClick, }) {
    return ((0, jsx_runtime_1.jsxs)(Button, { onClick: onClick, "data-e2e": 'InterimScreenRelaunchButton_Button', children: [(0, i18n_1.Localized)(i18n_1.Strings.auth.interimScreen.authInProgress.relaunchBrowser), (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.New_Window, width: 24, height: 24, "data-e2e": 'InterimScreenRelaunchButton_Icon' })] }));
}
exports.InterimScreenRelaunchButton = InterimScreenRelaunchButton;
const Button = styled_components_1.default.button `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;

  padding: 8px;

  font-size: 14px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${props => props.theme.designSystem.textSecondary};

  background: none;
  border: none;
  cursor: pointer;
`;
